<template>
	<ListAndCard
		:card-type="cardType"
		:image="report.image"
		:image-text="report.displayName"
		:url="report.url"
		:loading="report.saving"
	>
		<template slot="card-title">
			<div>
				<div class="headline mb-0">
					{{ report.displayName }}
				</div>
				<div class="text-xs-left" v-if="!isDateInReportName">{{ report.displayDate }}</div>
				<div>
					{{ report.stats.activeArticlesCount | formatNumber }}
					{{ report.stats.activeArticlesCount === 1 ? 'article' : 'articles' }}
				</div>
				<div v-if="report.lastActive">
					Last active {{ fromNow(report.lastActive) }}
				</div>
			</div>
		</template>
		<template slot="list-title">
			<div class="headline">{{ report.displayName }}</div>
			<div class="text-xs-left" v-if="!isDateInReportName">{{ report.displayDate }}</div>
		</template>
		<template slot="list-additional">
			<v-flex xs2 sm1>
				<div class="text-xs-center">
					{{ report.stats.activeArticlesCount | formatNumber }}
					{{ report.stats.activeArticlesCount === 1 ? 'Article' : 'Articles' }}
				</div>
			</v-flex>
			<v-flex xs2 sm1>
				<div class="text-xs-center">
					Last active {{ fromNow(report.lastActive) }}
				</div>
			</v-flex>
		</template>
		<template slot="actions">
			<v-btn
				:to="report.url"
				:disabled="report.saving"
				ripple
				flat
			>
				View
			</v-btn>
			<v-spacer v-if="cardType !== 1"/>
			<v-menu
				top
				left
			>
				<v-btn
					v-if="canManageReports"
					slot="activator"
					:disabled="report.saving"
					small
					icon
				>
					<v-icon>more_vert</v-icon>
				</v-btn>
				<v-list>
					<v-list-tile @click="$emit('edit', report)">
						<v-list-tile-title>Update</v-list-tile-title>
					</v-list-tile>
					<v-list-tile @click="$emit('archive', report)">
						<v-list-tile-title class="error--text">Archive Report</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>
		</template>
	</ListAndCard>
</template>

<script>
import ListAndCard from '@/components/ListAndCard';
import moment from 'moment';

export default {
	components: {
		ListAndCard,
	},
	props: {
		report: { type: Object, required: true },
		cardType: { type: Number, default: 0 },
	},
	computed: {
		canManageReports() {
			const project = this.report.projectModel;

			if (!project) {
				return false;
			}

			return this.report.projectModel.userCan('manage_reports');
		},
		isDateInReportName() {
			return this.report.displayName.includes(this.report.displayDate);
		},
	},
	methods: {
		fromNow(timestamp) {
			if ([null, '', '0000-00-00 00:00:00'].includes(timestamp)) {
				return 'Never';
			}
			return moment(`${timestamp}Z`).fromNow();
		},
	},
};
</script>

<style>

</style>
